'use client';

import { QueryClientProvider as Provider } from '@tanstack/react-query';
import { getQueryClient } from './getQueryClient';

const QueryClientProvider = ({ children }: { children: React.ReactNode }) => {
  const queryClient = getQueryClient();

  return <Provider client={queryClient}>{children}</Provider>;
};

export { QueryClientProvider };
